import { compose } from 'ramda';

import { getUserFullName } from './getUserFullName';

import { getInitials } from '@/shared/lib';


export const getUserInitials = compose(getInitials, getUserFullName);
